<template>
    <sweet-modal title="Change Presset" blocking ref="changePresset" v-on:close="closeModal">
        <el-form :model="formChangePresset" :rules="formChangePressetRules" ref="formChangePresset" class="demo-ruleForm">
            <el-form-item prop="projectListName">
                <el-select v-model="formChangePresset.pressetId" size="mini" placeholder="Presset">
                    <el-option v-for="item in pressetsList"
                               :key="item.id"
                               :label="$t(item.permissionPressetName)"
                               :value="item.id"
                               @click.native="setPresset(item)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-checkbox-group v-model="formChangePresset.permissionsIdArr">
                    <div v-for="(permissions, index) in permissionsList" :key="index" class="permissions">
                        <div class="permissions__title">{{$t(permissions.permissionFilterName)}}:</div>
                        <el-checkbox :disabled="disabledPermissions" v-for="(permission, index) in permissions.permissionList" @change="changePermission()" :label="permission.id" :key="index">{{$t(permission.permissionName)}}</el-checkbox>
                    </div>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button :disabled="disabledPermissions" @click="changePresset">Save</el-button>
            </el-form-item>
        </el-form>
    </sweet-modal>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "ChangePressetModal",
    props:[
      'selectedRows'
    ],
    components:{
      SweetModal
    },
    data(){
      return{
        pressetsList: [],
        permissionsList: [],
        disabledPermissions: true,
        formChangePresset:{
          pressetId: null,
          permissionsIdArr: []
        },
        formChangePressetRules:{
          pressetId: [
            { required: true, message: 'Field is required', trigger: 'blur' },
          ],
        },
      }
    },
    methods:{
      async openModal(){
        try {
          this.pressetsList = await this.getPressetList();

          this.permissionsList = await this.getPermissionsRulesList();

          this.$refs.changePresset.open()

        } catch (err) {
          console.log(err)
        }
      },
      getPressetList(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=1&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              const customPresset = {
                companyId: 0,
                id: 0,
                permissionGroup: 3,
                permissionPressetIdArr: [],
                permissionPressetName: "customPresset"
              };
              response.data.list.push(customPresset);
              resolve(response.data.list);
              loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        })
      },
      getPermissionsRulesList() {
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionRules/list?permissionGroup=1`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.list);
              loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        })
      },
      setPresset(presset){
        this.formChangePresset.permissionsIdArr = presset.permissionPressetIdArr;
        this.disabledPermissions = false
      },
      changePermission(){
        this.formChangePresset.pressetId = 0
      },
      changePresset(){
        // check if in selectedRows creator
        const leader = this.selectedRows.filter(user => user.leader);

        if (leader.length) {
          this.notification("Notification", `Cant change presset of ${leader[0].name}`, "info")
          return
        }

        const data = {
          companyId: Number(this.$route.query.companyId),
          permissions: this.formChangePresset.permissionsIdArr,
          pressetId: this.formChangePresset.pressetId,
          userIdList: this.selectedRows.map(user => user.uId)
        };

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUsers/assignBulkPermissions`, data)
          .then(response => {
            console.log('---', response.data);
            this.$emit('selected');
            this.$refs.changePresset.close();
            loader.hide()
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      closeModal(){
        this.pressetsList = [];
        this.permissionsList = [];
        this.disabledPermissions = true;
        this.formChangePresset.pressetId = null;
        this.formChangePresset.permissionsIdArr = []
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="less" scoped>
    .permissions {
        margin-bottom: 20px;
        &__title {
            font-size:16px;
            margin-bottom: 5px;
            color: #ccc;
        }
    }
</style>
